import React from "react";


const IconBlocks = ({ icon, title, children }) => {

    return (<div style={{ display: 'flex' }}>
        <img src={icon} style={{ width: '92px', height: '92px', marginTop: '25px', objectFit: 'contain' }} />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
            <label className="question">{title}</label>
            {children}
        </div>
    </div>)
}

export default IconBlocks